import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { BeatMark } from '../BeatMark';
import { useCart } from '../../contexts/CartContext';
const LINKS = [{
  label: 'Shop',
  to: '/shop'
}, {
  label: 'Cart',
  to: '/cart'
}, {
  label: 'The brand',
  to: '/'
}];
export function ShopNavigation() {
  const {
    count,
    open
  } = useCart();
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-beat-black/85 backdrop-blur" data-id="element-299" data-mp="1e27gzo5ns6d8">
      <div className="flex w-full items-center justify-between gap-3 px-4 py-2 md:px-8 md:py-3" data-id="element-300" data-mp="1itz9i48dkm60">
        <Link to="/" aria-label="BEAT Soda — home" className="-ml-4 md:-ml-6" data-id="element-301" data-mp="152kqhxegwkyy">
          <BeatMark className="w-32 md:w-44" data-id="element-302" data-mp="1a15f0zkcxg7k" />
        </Link>

        <nav className="flex items-center gap-1 sm:gap-4" data-id="element-303" data-mp="1a1nj2id9gyq1">
          {LINKS.map(link => <NavLink key={link.to} to={link.to} end className={({
          isActive
        }) => `hidden rounded-full px-4 py-2 text-sm font-medium transition-colors duration-150 sm:inline-flex ${isActive ? 'text-white' : 'text-white/50 hover:text-white'}`} data-id="element-304" data-mp="v4eprj4edkvo">
              {link.label}
            </NavLink>)}

          <button type="button" onClick={open} aria-label={`Open cart, ${count} item${count === 1 ? '' : 's'}`} className="relative inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-305" data-mp="3tnbjix2xypa0">
            <ShoppingBag size={18} data-id="element-306" data-mp="39xrdtvi5hx67" />
            {count > 0 && <span className="absolute -right-1 -top-1 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-beat-red px-1 text-[11px] font-medium text-white" data-id="element-307" data-mp="39w6m0dn80sc1">
                {count}
              </span>}
          </button>
        </nav>
      </div>
    </header>;
}